import { useMutation, useQuery } from '@tanstack/react-query';
import { useRecoilState } from 'recoil';

import { axiosInstance } from '../../axios/axiosInstance';
import { userData } from '../../recoil/atoms/userDataAtom';

const url = '/api/users/me';

export const useAuthMe = () => {
  const [, setData] = useRecoilState(userData);
  return useMutation(async () => {
    const { data } = await axiosInstance.get(url);
    setData(data);
    return data;
  });
};

export const useAuthMeQuery = () => {
  const [, setData] = useRecoilState(userData);
  return useQuery(
    ['ME'],
    async () => {
      const { data } = await axiosInstance.get(url);
      setData(data.data);
      return data.data;
    },
    {
      staleTime: Infinity,
    },
  );
};
